import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTemplates, deleteTemplate } from "../../../actions/admin/mail";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import TemplateItem from "./TemplateItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Template Name", width: "tw:w-[420px]" },
  { key: "customer", title: "Customer Template", width: "tw:w-[220px]" },
  { key: "action", title: "Action", width: "tw:w-[140px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const TemplateList = () => {
  const template_state = useSelector((state) => state.template);
  const { loading, templates } = template_state;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTemplates());
  }, [dispatch]);

  const delTempfromPopup = () => {
    dispatch(deleteTemplate(delId));
    dispatch(getTemplates());
    setDelId(null);
  };

  return (
    <AdminPage title="Email Template List" actions={<AdminCreateButton to="/admin/addemailtemplate" label="Add Email Template" />}>
      <AdminDeleteModal
        show={!!delId}
        title="Delete this email template?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={delTempfromPopup}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={900}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!templates?.length}
        emptyText="No email templates found."
      >
        {templates?.map((item, index) => (
          <TemplateItem key={item._id} template={item} count={index} deleteTemplate={setDelId} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default TemplateList;
